/**
 * 关于示范项目
 */
import React from 'react';
import './demonstration.scss';
import DynamicCard from '../DynamicCard/DynamicCard';
import white_bg from '../../assets/images/white_bg1.png';
import gray_bg from '../../assets/images/gray_bg1.png';

//lottie
import innovationPackage from '../../assets/lottie/innovativePackage/data.json';
import recyclingTechnology from '../../assets/lottie/recyclingTechnology/data.json';
import digitizing from '../../assets/lottie/digitizing/data.json';
import { s3Url } from '../AboutAward/AboutAward';

const Demonstration = () => {
  const focus = [
    {
      title: '绿色创新包装',
      lottieData: { data: innovationPackage, assetPath: '' },
    },
    {
      title: '绿色回收再生',
      lottieData: {
        data: recyclingTechnology,
        assetPath: s3Url,
      },
    },
    {
      title: '绿色供应链体系',
      lottieData: { data: digitizing, assetPath: '' },
    },
  ];
  const focusElement = focus.map((item) => {
    return (
      <div className='focus-item' key={item.title}>
        <div className='focus-lottie'>
          <DynamicCard title={item.title} lottieData={item.lottieData}></DynamicCard>
        </div>
        <div className='focus-title'>{item.title}</div>
      </div>
    );
  });
  return (
    <div className='demonstration'>
      <div className='focus-point'>
        <div className='time'>
          <div>
            <span className={'title-t-sp'}>3项</span>
            <span>聚焦领域</span>
          </div>
        </div>
        {focusElement}
      </div>
      <div className='demonstration-setting'>
        <div className='left-content'>
          <img src={gray_bg} alt='' />
          <div>
            <span className={'title-t-sp'} style={{ color: '#00D97E' }}>
              第二期
            </span>
            <span className='middle'>“科创中国”美团青山环保科技</span>
            <span style={{ marginTop: 8 }}>创新示范项目</span>
            {/* <span style={{ marginTop: 8 }}>资助说明</span> */}
          </div>
        </div>
        <div className='right-content'>
          <img src={white_bg} alt='' />
          <div className='inno-content-tip-next'>
            <div className='quota'>
              <span>资助数量</span>
              <span className='middle title-t-sp'>≤10</span>
              <span>面向中国境内依法注册的法人主体</span>
            </div>
            <div className='money'>
              <span>资助金额</span>
              <span className='middle title-t-sp'>≤3,000,000</span>
              <span>人民币/项目</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Demonstration;
